import LegalPageLayout from '../components/LegalPageLayout';

export default function ChildSafetyPage() {
  return (
    <LegalPageLayout title="Child Safety Standards" lastUpdated="April 5, 2026">
      <p>
        Family Waffle is committed to the safety and protection of children. We have zero tolerance
        for child sexual abuse material (CSAM) or any form of child exploitation on our platform.
        This page outlines our standards and practices for preventing, detecting, and responding to
        child sexual abuse and exploitation (CSAE).
      </p>

      <h2>1. Age Requirements</h2>
      <p>
        Family Waffle requires all users to be at least 13 years of age to create an account. Users
        between the ages of 13 and 18 must have parental or legal guardian consent to use the Service.
        If we become aware that a user is under the age of 13, we will promptly delete their account
        and all associated data.
      </p>

      <h2>2. Zero Tolerance for CSAM</h2>
      <p>
        Family Waffle maintains a strict zero-tolerance policy for child sexual abuse material (CSAM)
        and any content that exploits or endangers children. This includes, but is not limited to:
      </p>
      <ul>
        <li>Images, videos, or any visual depictions of child sexual abuse.</li>
        <li>Content that sexualizes minors in any way.</li>
        <li>Grooming behavior or attempts to solicit minors.</li>
        <li>Any content that promotes, glorifies, or facilitates child exploitation.</li>
      </ul>

      <h2>3. Reporting</h2>
      <p>
        If you encounter any content or behavior on Family Waffle that you believe involves child
        exploitation or abuse, please report it immediately through one of the following channels:
      </p>
      <ul>
        <li>
          <strong>In-app:</strong> Use the block feature to immediately prevent further contact
          with the user in question.
        </li>
        <li>
          <strong>Email:</strong> Contact us at{' '}
          <a href="mailto:developer@familywaffle.com">developer@familywaffle.com</a> with details of the
          concern. Include any relevant information that can help us investigate.
        </li>
      </ul>
      <p>
        All reports are treated with the highest priority and strict confidentiality.
      </p>

      <h2>4. Our Response Process</h2>
      <p>
        When we receive a report of potential CSAM or child exploitation, we take the following steps:
      </p>
      <ul>
        <li>Immediate review and investigation of the reported content or behavior.</li>
        <li>Immediate suspension of the account in question pending investigation.</li>
        <li>Preservation of relevant evidence for law enforcement.</li>
        <li>
          Reporting to the National Center for Missing & Exploited Children (NCMEC) via CyberTipline,
          as required by U.S. law, and to other relevant authorities as applicable.
        </li>
        <li>Permanent termination of the offending account.</li>
        <li>Cooperation with law enforcement agencies in any subsequent investigation.</li>
      </ul>

      <h2>5. Platform Safety Measures</h2>
      <p>
        Family Waffle implements the following measures to promote child safety on our platform:
      </p>
      <ul>
        <li>
          <strong>Invitation-only connections:</strong> Users can only interact with people they have
          explicitly invited or accepted as connections. There is no public discovery or open social
          networking.
        </li>
        <li>
          <strong>User blocking:</strong> Any user can block another user at any time, immediately
          preventing all further interaction.
        </li>
        <li>
          <strong>Account termination:</strong> We reserve the right to immediately and permanently
          terminate any account that violates our child safety policies, without prior notice.
        </li>
      </ul>

      <h2>6. Contact</h2>
      <p>
        For any questions or concerns related to child safety on Family Waffle, please contact us:
      </p>
      <p>
        <a href="mailto:developer@familywaffle.com">developer@familywaffle.com</a>
      </p>
    </LegalPageLayout>
  );
}
